import _ from 'lodash';

export const OBJECT_ID_REGEX = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i;

export function isDashboardWithoutId(path) {
  if (path === '/') {
    return true;
  }

  if (path.indexOf('/wallboard') > -1 && path.indexOf('/config') === -1) {
    return true;
  }

  if (new RegExp(/\/report\/\S+\//i).test(path)) {
    return true;
  }

   if (new RegExp(/\/portfolios\/\S+\//i).test(path)) {
    return true;
  }

  const val =
    _.filter(
      [
        '/dashboard',
        '/cfd',
        '/cta',
        '/ctsp',
        '/ctb',
        '/cth',
        '/trc',
        '/th',
        '/fe',
        '/ddp',
        '/montecarlodates',
        '/montecarlotasks',
        '/forecasts'
      ],
      p => {
        return p === path;
      }
    ).length > 0;

  return val;
}

export function isChartPage(path) {
  if (path === '/' || path === '/') {
    return true;
  }

  if (path.indexOf('/wallboard') > -1 && path.indexOf('/config') === -1) {
    return true;
  }

  // if (new RegExp(/\/report\/\S+\//i).test(path)) {
  //   return true;
  // }

  const val =
    _.filter(
      [
        '/dashboard/',
        '/cfd',
        '/cta',
        '/ctsp',
        '/ctb',
        '/cth',
        '/trc',
        '/th',
        '/fe',
        '/ddp',
        '/montecarlodates',
        '/montecarlotasks',
        '/forecasts'
      ],
      p => {
        return path.indexOf(p) > -1;
      }
    ).length > 0;

  return val;
}

export function noLinks(path) {
  if (path.indexOf('/update') > -1) {
    return true;
  }
  if (path.indexOf('/wallboard') > -1) {
    return true;
  } 
  if (path.indexOf('/dashboards') > -1) {
    return true;
  }
  if (path.indexOf('/permissions') > -1) {
    return true;
  }
  if (path.indexOf('/settings') > -1) {
    return true;
  }
  if (path.indexOf('/forecasting') > -1) {
    return true;
  }
  if (path.indexOf('/consent') > -1) {
    return true;
  }

  return (
    _.filter(
      [       
        '/tenant/config',
        '/sso/config',
        '/configure',
        '/portfolio',
        '/users',
        '/billing',
        '/create',
        '/subscribe',
        '/upgrade',
        '/terms',
        '/welcome',
        '/unlicensed',
        '/awaiting',
        '/awaiting/sso',
        '/akb',
        '/addon',
        '/chat',
        '/policy',
        '/expired',
        '/premium',
        '/cancelled',
        '/no-manage-billing',
        '/no-create-dashboard-permissions',
        '/no-value-stream-permissions',
        '/401',
        '/404',
        '/500'
      ],
      p => {
        return path === p;
      }
    ).length > 0
  );
}

export function noHeader(path) {
  if (path.indexOf('/reset') > -1) {
    return true;
  }
  if (path.indexOf('/sso/login') > -1) {
    return true;
  }

  return (
    _.filter(
      [
        '/login',
        '/complete',
        '/setup',
        '/downtime',
        '/limitreached',
        '/free',
        '/terms',
        '/welcome',
        '/unlicensed',
        '/error',
        '/awaiting',
        '/awaiting/sso',
        '/akb',
        '/addon',
        '/policy',
        '/register',
        '/hosts',
        '/hosts-not-allowed',
        '/forgotpassword',
        '/404',
        '/reset'
      ],
      p => {
        return path === p;
      }
    ).length > 0
  );
}

export function noFilter(path) {
  if (path.indexOf('/forecasts') > -1) {
    return true;
  }  
}

export function isWallboard(path) {
  if (path.indexOf('/wallboard') > -1 && path.indexOf('/config') === -1) {
    return true;
  }
  if (path.indexOf('/unlicensed') > -1) {
    return true;
  }
  if (new RegExp(/\/report\/\S+\//i).test(path)) {
    return true;
  }
   if (new RegExp(/\/portfolios\/\S+\//i).test(path)) {
    return true;
  }
}

export function isConsent(path) {
  if (path.indexOf('/consent') > -1) {
    return true;
  }
}

export function isProcessImprovement(path) {
  return /^\/dashboard\/[^/]+\/process\/?$/.test(path);
}

export function isLogin(path) {
  if (path.indexOf('/login') > -1) {
    return true;
  }
}

export default {
  OBJECT_ID_REGEX,
  isDashboardWithoutId,
  isChartPage,
  noLinks,
  noHeader,
  noFilter,
  isWallboard,
  isConsent,
  isLogin,
  isProcessImprovement
};
